
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import Home from './components/Home/Home';
import Login from './components/Auth/Login';
import ForgetPassword from './components/Auth/ForgetPassword';
import Register from './components/Auth/Register';
// import ProtectedRoute from './components/ProtectedRoute';
import AdminHeader from './components/AdminHeader/Header';
import UserHeader from './components/UserHeader/Header';
// import Footer from './components/Footer/Footer';
import { isAuthenticated, isAdmin, isUser } from './utils/auth';
import authService from './services/authService';
import { useLocation, useNavigate } from 'react-router-dom';

// Admin components
import AdminDashboard from './AdminExamination/AdminDashboard/Dashboard/Dashboard';
import AssignExam from './AdminExamination/AdminDashboard/Pages/AssignExam/AssignExam';
import AddQuestion from './AdminExamination/AdminDashboard/Pages/AddQuestion/AddQuestion';
import AdminReports from './AdminExamination/AdminDashboard/Pages/Reports/Reports';
import ViewQuestion from './AdminExamination/AdminDashboard/Pages/ViewQuestion/ViewQuestion';
import Questions from './AdminExamination/AdminDashboard/Pages/QuestionCreation/Questions';
import AssignHistory from './AdminExamination/AdminDashboard/Pages/AssignExamHistory/AssignHistory';
import ExamMasterList from './AdminExamination/AdminDashboard/Pages/ExamMasterList/ExamMasterList';
import CreateTraining from './AdminExamination/AdminDashboard/Pages/TrainingSection/TrainingSection';
import AdminProfile from './AdminExamination/AdminDashboard/Pages/AdminProfile/AdminProfile';

// User components
import UserDashboard from './UserExamination/DashboardAfterLogin/Dashboard/Dashboard';
import Faq from './UserExamination/DashboardAfterLogin/Dashboard/FAQ/Faq';
import UserProfile from './UserExamination/DashboardAfterLogin/Pages/Profile/Profile';
import Quiz from './UserExamination/DashboardAfterLogin/Pages/ExaminationSection/QuizExam/Quiz';
import ExamResult from './UserExamination/DashboardAfterLogin/Pages/ExaminationSection/ExamResult/ExamResult';
import UserReports from './UserExamination/DashboardAfterLogin/Pages/Reports/UserReports';
// import ExamPreparation from './UserExamination/DashboardAfterLogin/Pages/TrainingModules/ExamPreparation';
import TrainingSection from './UserExamination/DashboardAfterLogin/Pages/TrainingPage/TrainingDashboard';
import TrainingVideos  from './UserExamination/DashboardAfterLogin/Pages/TrainingPage/TrainingVideos';
import ExamQuiz from './UserExamination/DashboardAfterLogin/Pages/ExaminationSection/ExamQuiz/ExamQuiz';

const RootRedirect = () => {
  if (!isAuthenticated()) {
    return <Home />;
  }
  if (isAdmin()) {
    return <Navigate to="/dashboard" replace />;
  }
  if (isUser()) {
    return <Navigate to="/user/dashboard" replace />;
  }
  return <Navigate to="/" replace />;
};

// -----------------------------------Start Add new code for token handler -----------------------------------
const TokenHandler = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');

    const handleTokenAuth = async () => {
      if (token && !authService.isAuthenticated()) {
        setIsProcessing(true);
        try {
          await authService.loginWithToken(token);
          navigate(location.pathname, { replace: true });
        } catch (error) {
          console.error('Token authentication failed:', error);
          navigate('/login', { replace: true });
        } finally {
          setIsProcessing(false);
        }
      }
    };

    handleTokenAuth();
  }, [location, navigate]);

  if (isProcessing) {
    return <div>Authenticating...</div>;
  }

  return children;
};

const ProtectedRoute = ({ allowedRoles }) => {
  const location = useLocation();

  const isAllowed = () => {
    if (allowedRoles.includes('admin') && authService.isAdmin()) return true;
    if (allowedRoles.includes('user') && authService.isUser()) return true;
    return false;
  };

  return (
    <TokenHandler>
      {authService.isAuthenticated() ? (
        isAllowed() ? (
          <Outlet />
        ) : (
          <Navigate to="/" replace state={{ from: location }} />
        )
      ) : (
        <Navigate to="/login" replace state={{ from: location }} />
      )}
    </TokenHandler>
  );
};
// -----------------------------------End Add new code for token handler -----------------------------------
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/external-auth" element={<RootRedirect />} />
       
        <Route path="/" element={<RootRedirect />} />

      
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgetPassword />} />
        <Route path="/register" element={<Register />} />

        {/* Protected Admin Routes */}
        <Route element={<ProtectedRoute allowedRoles={['admin']} />}>
          <Route element={<AdminLayout />}>
            <Route path="/dashboard" element={<AdminDashboard />} />
            <Route path="/assign-exam" element={<AssignExam />} />
            <Route path="/add-question" element={<AddQuestion />} />
            <Route path="/reports" element={<AdminReports />} />
            <Route path="/view-question" element={<ViewQuestion />} />
            <Route path="/question" element={<Questions />} />
            <Route path="/assign-history" element={<AssignHistory />} />
            <Route path="/exam-master" element={<ExamMasterList />} />
            <Route path="/create-training" element={<CreateTraining />} />
            <Route path="/profile" element={<AdminProfile />} />

          </Route>
        </Route>

        {/* Protected User Routes */}
        <Route element={<ProtectedRoute allowedRoles={['user']} />}>
          <Route element={<UserLayout />}>
            <Route path="/user/dashboard" element={<UserDashboard />} />
            <Route path="/user/faq" element={<Faq/>} />
            <Route path="/user/profile" element={<UserProfile />} />
            <Route path="/user/startexam/:examId" element={<Quiz />} />
            <Route path="/user/start-exam-quiz/:examId" element={<ExamQuiz />} />
            <Route path="/user/results" element={<ExamResult />} />
            <Route path="/user/reports" element={<UserReports />} />
            <Route path="/user/training/" element={<TrainingSection />} />
            <Route path="/user/training/:trainingId" element={<TrainingVideos />} />
          </Route>
        </Route>

       
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

const AdminLayout = () => (
  <>
    <AdminHeader />
    <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
      <Outlet />
    </div>
  </>
);

const UserLayout = () => (
  <>
    <UserHeader />
    <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
      <Outlet />
    </div>
    {/* <Footer /> */}
  </>
);

export default App;